'use strict';
// TODO: Remove from `core-js@4`
var $ = require('../internals/export');
var indexed = require('../internals/iterator-indexed');

// `Iterator.prototype.asIndexedPairs` method
// https://github.com/tc39/proposal-iterator-helpers
$({ target: 'Iterator', name: 'indexed', proto: true, real: true, forced: true }, {
  asIndexedPairs: indexed
});
